export const PARENT_ENTITES = [
    { name: 'page', type: 'page' },
    { name: 'account', type: 'brands' },
    { name: 'collection', type: 'collections' },
    { name: 'pack', type: 'packs' },
];